module.exports = __webpack_public_path__ + "static/img/card_4_1.87110bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/card_4_1.png
// module id = mAeD
// module chunks = 0